<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <upload-payslip>
        </upload-payslip> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import uploadPayslip from './todo-upload-payslip'
export default {
    components: {
        uploadPayslip
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-payroll/base-upload-payslip.vue